<section class="funcionalidades-screen">
  <header class="funcionalidades-screen__header">
    <h1 class="page-main-title">Cadastro e Parametrização</h1>
    <p class="funcionalidades-screen__subtitulo">
      Escolha o que você quer administrar no perfil de investimento.
    </p>
  </header>

  <div class="funcionalidades-grid">
    @for (item of funcionalidades; track item.rota) {
      <button
        type="button"
        class="funcionalidade-card"
        [class.funcionalidade-card--disabled]="item.desabilitado"
        [disabled]="item.desabilitado"
        [attr.aria-disabled]="item.desabilitado"
        (click)="navegar(item)"
      >
        <span class="funcionalidade-card__topo">
          <!-- O ícone é decorativo: o título ao lado já nomeia a funcionalidade. -->
          <span class="funcionalidade-card__icone" aria-hidden="true">
            <svg
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              stroke-width="1.8"
              stroke-linecap="round"
              stroke-linejoin="round"
            >
              @switch (item.icone) {
                @case ('campanhas') {
                  <path d="M3 11v2a1 1 0 0 0 1 1h3l5 4V6L7 10H4a1 1 0 0 0-1 1z" />
                  <path d="M16 8a5 5 0 0 1 0 8" />
                }
                @case ('perfis') {
                  <path d="M16 20v-1.5a4 4 0 0 0-4-4H6a4 4 0 0 0-4 4V20" />
                  <circle cx="9" cy="7" r="3.5" />
                  <path d="M22 20v-1.5a4 4 0 0 0-3-3.87" />
                  <path d="M16 3.6a4 4 0 0 1 0 7.3" />
                }
                @case ('questionarios') {
                  <rect x="5" y="3" width="14" height="18" rx="2" />
                  <path d="M9 8h6M9 12h6M9 16h3" />
                }
                @case ('integracao') {
                  <path d="M4 8h12l-3-3M20 16H8l3 3" />
                }
                @case ('termos') {
                  <path d="M14 3H7a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h10a2 2 0 0 0 2-2V8z" />
                  <path d="M14 3v5h5M9 13h6M9 17h4" />
                }
              }
            </svg>
          </span>

          @if (item.desabilitado) {
            <span class="funcionalidade-card__tag" data-testid="funcionalidade-tag">Em breve</span>
          } @else {
            <span class="funcionalidade-card__seta" aria-hidden="true">&#8594;</span>
          }
        </span>

        <span class="funcionalidade-title">{{ item.titulo }}</span>
        <span class="funcionalidade-card__descricao">{{ item.descricao }}</span>
      </button>
    }
  </div>
</section>
